import React, { Component } from "react";
import Axios from "axios";
import Loading from "./Loading";
import "@fortawesome/fontawesome-free/css/all.min.css";

class Cek extends Component {
  constructor(props) {
    super(props);
    this.onHandleNikChange = this.onHandleNikChange.bind(this);
    this.goCek = this.goCek.bind(this);
  }
  state = {
    nik: "",
    regexp: /^[0-9\b]+$/,
    angka1: "",
    angka2: "",
    jumlah: "",
    total: "",
    isResultShow: 0,
    data: "",
    errorForm: "",
    isFormValid: 0,
    loading: false,
    errorApi: "",
  };

  componentDidMount() {
    //console.log('componentDidMount');
    var self = this;
    Axios.get("http://semangat.dukcapilbogorkab.id/apidisduk")
      .then(function (response) {
        self.setState({
          token: response.data.token,
        });
      })
      .catch(function (error) {
        //console.log(error);
      })
      .then(function () {
        // always executed
      });
    this.cap();
  }
  cap() {
    let angka1 = Math.ceil(Math.random() * 20);
    let angka2 = Math.ceil(Math.random() * 20);
    let total = angka1 + angka2;
    this.setState({
      angka1: angka1,
      angka2: angka2,
      total: total,
    });
  }

  onHandleNikChange = (e) => {
    let nik = e.target.value;
    // if value ga blank, maka test regex
    if (nik === "" || this.state.regexp.test(nik)) {
      this.setState({ [e.target.name]: nik });
    }
  };

  jumlah = (e) => {
    this.setState({
      jumlah: e.target.value,
    });
  };

  goCek = () => {
    this.setState({
      isResultShow: 1,
    });
    if (!this.state.nik) {
      this.cap();
      this.setState({
        isFormValid: 0,
        data: 0,
        resMessage: "",
        errorForm: (
          <div style={{ textAlign: "center", backgroundColor: "#ff3030", color: "#fff" }} key="data" className="alert" role="alert">
            <i className="far fa-times-circle fa-4x"></i>
            <br />
            <br />
            Masukan NIK Kamu
          </div>
        ),
      });
    } else {
      this.cap();
      if (parseInt(this.state.jumlah) !== this.state.total) {
        this.setState({
          isFormValid: 0,
          data: 0,
          resMessage: "",
          errorForm: (
            <div style={{ textAlign: "center", backgroundColor: "#ff3030", color: "#fff" }} key="data" className="alert" role="alert">
              <i className="far fa-times-circle fa-4x"></i>
              <br />
              <br />
              Captcha salah
            </div>
          ),
        });
      } else {
        this.a();
      }
    }
  };

  a = () => {
    this.cap();
    this.setState({
      isFormValid: 1,
      errorForm: "",
      isLoading: true,
    });
    this.setState({ loading: true }, () => {
      Axios.interceptors.request.use(
        function (config) {
          // Do something before request is sent
          //console.log('Start Axios Call')
          return config;
        },
        function (error) {
          // Do something with request error
          //console.log('Error');
          return Promise.reject(error);
        }
      );

      Axios.interceptors.response.use(
        function (response) {
          // Do something with response data
          //console.log('Done with Axios call');

          return response;
        },
        function (error) {
          // Do something with response error
          //console.log('Error fetching the data');
          return Promise.reject(error);
        }
      );

      const config = {
        headers: {
          Authorization: "Bearer " + this.state.token,
        },
      };
      const param = {
        nik: this.state.nik,
        code: "silhcum",
      };

      Axios.post("http://semangat.dukcapilbogorkab.id/apidisduk/ceknik", param, config)
        .then((response) => {
          //console.log(response);
          if (response.data.message === "Data ditemukan") {
            this.setState({
              data: 1,
              isLoading: false,
              loading: false,
              nik: "",
              jumlah: "",
              resMessage: response.data.message,
              resNik: response.data.data.NIK,
              resNama: response.data.data.NAMA_LGKP,
              resWajibKtp: response.data.data.WAJIB_KTP,

              resStatSuket: response.data.data.SUKET_STATUS,
              resTglCetakSukeTerakhir: response.data.data.SUKET_CETAK_TGL_TERAKHIR,

              resStatPengajuan: response.data.data.PENGAJUAN_KTP_STATUS,
              resTglPengajuanKtp: response.data.data.PENGAJUAN_KTP_STATUS_TGL_TERAKHIR,

              resStatCetak: response.data.data.KTP_CETAK_STATUS,
              resTglKtp: response.data.data.KTP_CETAK_TGL_TERAKHIR,

              resStatBa: response.data.data.DISTRIBUSI_STATUS,
              resTglBa: response.data.data.DISTRIBUSI_TGL,

              resStatTerima: response.data.data.STATUS_TERIMA,
              restglTerima: response.data.data.TGL_TERIMA,
              resditerimaOleh: response.data.data.DITERIMA_OLEH,
            });
          } else {
            this.setState({
              data: 0,
              isLoading: false,
              loading: false,
              // resMessage: response.data.message
              resMessage: (
                <div style={{ textAlign: "center", backgroundColor: "#ff3030", color: "#fff" }} key="data" className="alert" role="alert">
                  <i className="far fa-times-circle fa-4x"></i>
                  <br />
                  <br />
                  Maaf Ya... Data kamu tidak ditemukan, tolong periksa kembali NIK Kamu
                </div>
              ),
            });
          }
        })
        .catch((error) => {
          //console.log(error);
          this.setState({
            data: 0,
            isLoading: false,
            loading: false,
            errorApi: (
              <div style={{ textAlign: "center", backgroundColor: "#ff3030", color: "#fff" }} key="data" className="alert" role="alert">
                <i className="far fa-times-circle fa-4x"></i>
                <br />
                <br />
                Tidak bisa terhubung, Silahkan refresh browser kamu
              </div>
            ),
          });
        });
    });
  };

  render() {
    // const { data, loading } = this.state;
    const { loading } = this.state;

    return (
      <div>
        <br />
        <br />
        <div className="row">
          <div className="col-md-6"></div>
        </div>
        <div className="container">
          <div className="text-center">
            <img className="img-responsive center-block" src={process.env.PUBLIC_URL + "/logo.png"} />
          </div>
          <br />
          <div className="text-center">
            <b>Yuk.. Cek Pengajuan E-ktp mu </b>
          </div>
        </div>

        <br />

        <div className="container">
          <div className="row justify-content-md-center">
            <label className="col-sm-2 col-form-label">
              <b>NIK Kamu</b>
            </label>
            <div className="col-md-4 mb-3">
              <input type="text" name="nik" placeholder="Masukkan NIK Kamu" value={this.state.nik} onChange={this.onHandleNikChange} maxLength="16" className="form-control" />
            </div>
          </div>
        </div>
        <div className="container">
          <div className="row justify-content-md-center">
            <label className="col-sm-2 col-form-label">
              <b>
                Berapa {this.state.angka1} + {this.state.angka2} ?
              </b>
            </label>
          </div>
        </div>

        <div className="container">
          <div className="row justify-content-md-center">
            <label className="col-sm-2 col-form-label">
              <b>Captcha</b>
            </label>
            <div className="col-md-4 mb-3">
              <input type="number" name="jumlah" placeholder="Masukkan Jumlah" value={this.state.jumlah} onChange={this.jumlah} maxLength="16" className="form-control" />
              <br />

              <button className="btn btn-primary  float-right" onClick={this.goCek} disabled={this.state.isLoading}>
                <i className="fas fa-search"></i> Cek Yuk
              </button>
            </div>
          </div>
        </div>

        {/* <br />
                nik {this.state.nik}
                <br />
                angka1 {this.state.angka1}
                <br />
                angka2 {this.state.angka2}
                <br />
                total {this.state.total}
                <br />
                jumlah {this.state.jumlah}
                <br />
                isResultShow {this.state.isResultShow}
                <br />
                isFormValid {this.state.isFormValid}
                <br />
                data {this.state.data}
                <br />
                error form {this.state.errorForm} */}

        <div className="container">
          <div className="row justify-content-md-center">
            <label className="col-sm-2 col-form-label">{loading ? <Loading /> : <div></div>}</label>
          </div>
        </div>

        {this.state.isFormValid === 0 ? (
          <div>
            <div className="container">
              <div className="row justify-content-md-center">
                <div className="col-md-12">{this.state.errorForm}</div>
              </div>
            </div>
          </div>
        ) : (
          <div></div>
        )}

        {this.state.errorApi ? (
          <div className="container">
            <div className="row justify-content-md-center">
              <div className="col-md-12">{this.state.errorApi}</div>
            </div>
          </div>
        ) : (
          <div>
            <div className="container">
              <div className="row justify-content-md-center">
                <div className="col-md-12">
                  {this.state.data === 1 ? (
                    <div>
                      {/* {this.state.resMessage} */}
                      {this.state.resStatCetak === 1 ? (
                        <div style={{ backgroundColor: "#32afed", textAlign: "center" }} key="data" className="alert" role="alert">
                          <i className="far fa-check-circle fa-4x"></i>
                          <br />
                          <br />
                          <div>
                            Yey.. Selamat ya <b>{this.state.resNama}</b> KTP Kamu sudah Dicetak
                            <br />
                            Tanggal Cetak Terakhir : <b>{this.state.resTglKtp}</b>
                          </div>
                          {this.state.resStatBa === 0 ? (
                            <div></div>
                          ) : (
                            <div>
                              KTP Kamu sudah sampai di Kecamatan Tanggal : <b>{this.state.resTglBa}</b>
                              <div>
                                {this.state.resStatTerima === 0 ? (
                                  <div></div>
                                ) : (
                                  <div>
                                    Di terima oleh : <b>{this.state.resditerimaOleh}</b> tanggal : <b>{this.state.restglTerima}</b>
                                  </div>
                                )}
                              </div>
                            </div>
                          )}
                        </div>
                      ) : (
                        <div key="data" style={{ backgroundColor: "#ffdd00", textAlign: "center" }} className="alert" role="alert">
                          <i className="fas fa-exclamation-circle fa-4x"></i>
                          <br />
                          <br />
                          <div>
                            Maaf ya <b>{this.state.resNama}</b> KTP Kamu Belum di cetak
                          </div>
                          {this.state.resStatPengajuan === 0 ? (
                            <div>KTP kamu Belum diajukan</div>
                          ) : (
                            <div>
                              KTP kamu sudah diajukan tanggal : <b>{this.state.resTglPengajuanKtp}</b>
                            </div>
                          )}
                        </div>
                      )}
                    </div>
                  ) : (
                    <div>
                      <div>{this.state.resMessage}</div>
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
        )}
      </div>
    );
  }
}

export default Cek;
